import { makeStyles } from '@material-ui/core/styles';

const mappedClasses = [
  'gntc-single-content-card',
  'gntc-content-card',
  'gntc-content-card-small',
  'gntc-cta',
  'gntc-row-card',
  'gntc-default-card',
  'gntc-intro-content',
  'gntc-dashboard-card',
  'gntc-account-detail-content-card',
  'gntc-portal-carousel-content-card',
];

export const usePageComponentsFeatureStyles = makeStyles(() => {
  const roundedSelector = mappedClasses.map((c) => `& .${c}`).join(',');

  return {
    '@global': {
      '.global-component--rounded': ({ radius, excludedIds = [] }: any) => {
        const excludedComponentIds = excludedIds
          .map((id: string) => `:not([data-component-id="${id}"])`)
          .join('');
        const globalSelector = `& [data-component-id]${excludedComponentIds}`;

        return {
          [globalSelector]: {
            [roundedSelector]: {
              borderRadius: radius,
            },
            '& .gntc-detail-content': {
              '& .gntc-image > img:not(.swiper-slide img)': {
                borderRadius: radius,
              },
            },
            '& .gntc-horizontal-top-content': {
              borderBottomLeftRadius: radius,
              borderBottomRightRadius: radius,
            },
            '& .gntc-horizontal-top-content-tabs': {
              borderTopLeftRadius: radius,
              borderTopRightRadius: radius,
              borderBottomRightRadius: radius,
            },
            '& .gntc-search-bar': {
              '& .MuiInputBase-root': {
                borderTopLeftRadius: radius,
                borderBottomLeftRadius: radius,
              },
              '& .MuiButtonBase-root': {
                borderTopRightRadius: radius,
                borderBottomRightRadius: radius,
              },
            },
          },
        };
      },
    },
  };
});
